import Footer from "../components/footer";
import Header from "../components/header";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import React, { useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../i18n";

export default function Discover() {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  // Doğru component adı
  const galleryImages = [
    { src: "/assets/dateing-1.png", alt: "Telefonda tanışma" },
    { src: "/assets/dateing-2.png", alt: "Cafe ortamında sohbet" },
    { src: "/assets/dateing-3.png", alt: "Restaurant buluşması" },
    { src: "/assets/dateing-4.png", alt: "Bar'da tanışma" },
  ];

  const usageLocations = [
    {
      image: "/assets/whereUsed-1.png",
      title: "Konserlerde İzini Bırak",
      description:
        "Katıldığınız konserde sizde izinizi bırakacak bir şeyler yazın.",
    },
    {
      image: "/assets/whereUsed-2.png",
      title: "Festivallerde İzini Bırak",
      description: "Festival deneyiminizi zenginleştirin",
    },
    {
      image: "/assets/whereUsed-3.png",
      title: "Barlar ve Gece Kulüplerinde Kullanım",
      description:
        "Gece hayatında sosyalleşme, tema geceleri ve güvenli tanışma imkanları",
    },
  ];

  const phoneScreens = [
    { src: "/assets/phoneScreen-1.png", alt: "Kullanıcı Profili" },
    { src: "/assets/phoneScreen-2.png", alt: "Avatar Seçimi" },
    { src: "/assets/phoneScreen-3.png", alt: "Harita Görünümü" },
    { src: "/assets/phoneScreen-4.png", alt: "Kullanıcı Bilgileri" },
    { src: "/assets/phoneScreen-5.png", alt: "Sohbet Ekranı" },
  ];

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Header */}
      <Header isHomePage={false} />

      {/* Hero Section */}

      <section className="relative w-full h-[220px] sm:h-[220px] md:h-[440px] lg:h-[440px] overflow-hidden ">
        <div className="absolute inset-0 ">
          <img
            src="/assets/allfriends.png"
            alt="Keşfet"
            className="w-full h-full object-cover object-center"
            loading="lazy"
          />
        </div>
        <div className="absolute inset-0 flex items-end  ">
          <div className="container mx-auto px-4 sm:px-6 md:px-8 pb-4 sm:pb-8 md:pb-12 lg:pb-16  lg:px-10 xl:px-28">
            <h2 className=" text-3xl md:text-[42px] font-bold font-poppins sm:text-3xl md:text-4xl lg:text-[54px]    text-white text-start  sm:text-left max-w-xs sm:max-w-sm md:max-w-2xl mx-auto sm:mx-0">
              {t("WhyQriend")}
            </h2>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="container mx-auto px-4 py-4 sm:py-6 md:py-8 lg:py-10 ">
        <div className=" px-4 lg:px-10 xl:px-24 ">
          <h1 className=" text-3xl md:text-[42px] font-bold font-poppins   sm:text-2xl md:text-3xl lg:text-[45px]   text-[#2F327D] mb-3 sm:mb-4 md:mb-6 lg:mb-8 text-left md:leading-[60px] lg:leading-[60px]">
            {t("DiscoverTitle")}
          </h1>

          <p className="text-lg md:text-[21px] font-poppins   text-[#797979]  text-left lg:leading-[30px]">
            {t("DiscoverDesc")}
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="container mx-auto px-4 ">
        <div className="px-4 lg:px-10 xl:px-24">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
            {galleryImages.map((image, index) => (
              <div
                key={index}
                className="bg-white rounded-lg sm:rounded-xl shadow-sm overflow-hidden transition-transform hover:scale-105"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="container mx-auto px-4 py-6 sm:py-8 md:py-12 lg:py-16">
        <div className=" px-4 lg:px-10 xl:px-24 mx-auto">
          {/* <h1 className="text-2xl sm:text-2xl md:text-3xl lg:text-[42px] font-semibold font-poppins text-[#2F327D] mb-4 sm:mb-6 md:mb-8 text-center sm:text-left">
            Neden Bizi Tercih Etmelisiniz?
          </h1> */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
            <div className="space-y-4 md:space-y-6 lg:space-y-8 text-center sm:text-left">
              <p className="text-lg md:text-[21px] font-poppins   text-[#797979] text-center sm:text-left">
                {t("DiscoverEp2")}
              </p>
              <div className="relative max-w-[280px] sm:max-w-none mx-auto sm:mx-0">
                <img
                  src="/assets/whyPreferQRiend4.png"
                  alt="Qriend Uygulaması"
                  className="w-full h-auto object-cover rounded-xl sm:rounded-2xl md:rounded-[32px] shadow-[-10px_10px_25px_0px_#F231C866]"
                  loading="lazy"
                />
              </div>
            </div>

            {/* Right Side - Features */}
            <div className="space-y-4 sm:space-y-6 md:space-y-8 text-center sm:text-left pt-12 ">
              {/* Feature 1 */}
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-3 sm:gap-4">
                <div className="flex-shrink-0 w-[50px] sm:w-[60px] md:w-[70px]">
                  <img
                    src="/assets/whyPreferQRiend1.png"
                    alt=""
                    className="w-12 sm:w-16 md:w-20 lg:w-[92px] h-auto mx-auto sm:mx-0"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-lg md:text-xl font-poppins text-[#292D33] mb-3 sm:mb-2">
                    {t("DiscoverEp2Dot")}
                  </h3>
                  <p className="text-lg sm:text-sm md:text-base font-poppins text-[#9497A1]">
                    {t("DiscoverEp2DotDesc")}
                  </p>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-3 sm:gap-4 border-y border-gray-200/50 py-4 sm:py-6">
                <div className="flex-shrink-0 w-[50px] sm:w-[60px] md:w-[70px]">
                  <img
                    src="/assets/whyPreferQRiend2.png"
                    alt=""
                    className="w-12 sm:w-16 md:w-20 lg:w-[92px] h-auto mx-auto sm:mx-0"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-lg md:text-xl font-poppins text-[#292D33] mb-3 sm:mb-2">
                    {t("DiscoverEp3Dot")}
                  </h3>
                  <p className="text-lg sm:text-sm md:text-base font-poppins text-[#9497A1]">
                    {t("DiscoverEp3DotDesc")}
                  </p>
                </div>
              </div>

              {/* Feature 3 */}
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-3 sm:gap-4">
                <div className="flex-shrink-0 w-[50px] sm:w-[60px] md:w-[70px]">
                  <img
                    src="/assets/whyPreferQRiend3.png"
                    alt=""
                    className="w-12 sm:w-16 md:w-20 lg:w-[92px] h-auto mx-auto sm:mx-0"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-lg md:text-xl font-poppins text-[#292D33] mb-3 sm:mb-2">
                    {t("DiscoverEp4Dot")}
                  </h3>
                  <p className="text-lg sm:text-sm md:text-base font-poppins text-[#9497A1]">
                    {t("DiscoverEp4DotDesc")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* User Interface Section */}
      <section className="bg-[#FDECEE] py-6 sm:py-8 md:py-12 lg:py-16">
        <div className="container mx-auto px-4 lg:px-10 xl:px-24">
          <h2 className="text-3xl md:text-[42px] font-bold text-[#2F327D] font-poppins text-center mb-4 sm:mb-6 md:mb-8 lg:mb-10 max-w-[683px] mx-auto leading-tight sm:leading-snug md:leading-normal">
            {t("SwiperText")}
          </h2>

          {/* Carousel Bileşeni (Swiper) */}
          <div className="relative">
            {/* Navigasyon Butonları - Negatif margin ile Swiper alanının dışına çıkarıyoruz */}
            <button
              className="swiper-button-prev-custom absolute left-0 sm:-left-2 md:-left-4 lg:-left-6 xl:-left-8 top-1/2 transform -translate-y-1/2 z-10 bg-white/90 hover:bg-white text-[#E94057] w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#E94057] focus:ring-opacity-50"
              aria-label="Önceki Ekran"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6"
              >
                <path
                  fillRule="evenodd"
                  d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <button
              className="swiper-button-next-custom absolute right-0 sm:-right-2 md:-right-4 lg:-right-6 xl:-right-8 top-1/2 transform -translate-y-1/2 z-10 bg-white/90 hover:bg-white text-[#E94057] w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#E94057] focus:ring-opacity-50"
              aria-label="Sonraki Ekran"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6"
              >
                <path
                  fillRule="evenodd"
                  d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z"
                  clipRule="evenodd"
                />
              </svg>
            </button>

            {/* Swiper Container - Butonlar için alan bırakıyoruz */}
            <div className="px-8 sm:px-10 md:px-12 lg:px-16 xl:px-20">
              <Swiper
                effect={"coverflow"}
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={1}
                spaceBetween={10}
                loop={true}
                initialSlide={2}
                coverflowEffect={{
                  rotate: 0,
                  stretch: 0,
                  depth: 100,
                  modifier: 1,
                  slideShadows: false,
                }}
                navigation={{
                  nextEl: ".swiper-button-next-custom",
                  prevEl: ".swiper-button-prev-custom",
                }}
                breakpoints={{
                  640: {
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                    coverflowEffect: {
                      stretch: -30,
                      depth: 200,
                      slideShadows: false,
                    },
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                    coverflowEffect: {
                      stretch: -40,
                      depth: 250,
                      slideShadows: false,
                    },
                  },
                  1024: {
                    slidesPerView: "auto",
                    spaceBetween: 0,
                    coverflowEffect: {
                      stretch: -50,
                      depth: 300,
                      slideShadows: false,
                    },
                  },
                }}
                modules={[EffectCoverflow, Navigation]}
                className="h-[500px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] !pb-10"
                style={{
                  "--swiper-navigation-size": "30px",
                  "--swiper-navigation-color": "#E94057",
                }}
              >
                {phoneScreens.map((screen, index) => (
                  <SwiperSlide
                    key={index}
                    className="!w-full sm:!w-[320px] md:!w-[380px] lg:!w-[320px] xl:!w-[380px] flex justify-center"
                  >
                    <div className="flex justify-center items-center h-full w-full max-w-[350px] sm:max-w-[320px] md:max-w-[360px] lg:max-w-[320px] xl:max-w-[360px] mx-auto">
                      <img
                        src={screen.src}
                        alt={screen.alt}
                        className="block w-full h-auto max-h-[450px] sm:max-h-[450px] md:max-h-[550px] lg:max-h-[650px] xl:max-h-[750px] object-contain rounded-[20px] sm:rounded-[25px] md:rounded-[30px]"
                        loading="lazy"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          {/* Mobil için pagination dots (opsiyonel) */}
          <div className="flex justify-center mt-4 sm:hidden">
            <div className="swiper-pagination-custom flex gap-2"></div>
          </div>
        </div>
      </section>

      <section className="container max-w-[1171px] text-left mx-auto  py-6 sm:py-8 md:py-12 lg:py-16">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-3xl md:text-[42px] font-bold   font-poppins text-[#2F327D] mb-4 sm:mb-6 md:mb-8 text-center sm:text-left">
            {t("SafetyMeet")}
          </h1>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-32 items-center md:space-x-16 lg:space-x-16">
            <div className="order-2 lg:order-1 text-center sm:text-left">
              <div className="space-y-4 sm:space-y-6 md:space-y-8">
                <div className="flex flex-col sm:flex-row items-center sm:items-start gap-3 sm:gap-4 text-center sm:text-left">
                  <div className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 flex-shrink-0 mt-1">
                    <img
                      src="/assets/verify-2.png"
                      alt="Onay İkonu"
                      className="w-full h-full"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-xl md:text-2xl text-[#333333] font-poppins mb-3 sm:mb-4">
                      {t("RealTimeInteraction")}
                    </h3>
                    <ul className="text-[#6B7C93] space-y-2 sm:space-y-1 text-sm sm:text-base md:text-lg font-poppins">
                      <li>{t("RealTimeInteractionDesc")}</li>
                      <li>{t("RealTimeInteractionDesc2")}</li>
                      <li>{t("RealTimeInteractionDesc3")}</li>
                    </ul>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row items-center sm:items-start gap-3 sm:gap-4 text-center sm:text-left">
                  <div className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 flex-shrink-0 mt-1">
                    <img
                      src="/assets/verify-2.png"
                      alt="Onay İkonu"
                      className="w-full h-full"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg sm:text-xl md:text-2xl text-[#333333] font-poppins mb-3 sm:mb-4">
                      {t("SecureAndVerifiedEnvironment")}
                    </h3>
                    <ul className="text-[#6B7C93] space-y-2 sm:space-y-1 text-sm sm:text-base md:text-lg font-poppins">
                      <li>{t("SecureAndVerifiedEnvironmentDesc")}</li>
                      <li>{t("SecureAndVerifiedEnvironmentDesc2")}</li>
                      <li>{t("SecureAndVerifiedEnvironmentDesc3")}</li>
                    </ul>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row items-center sm:items-start gap-3 sm:gap-4 text-center sm:text-left">
                  <div className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 flex-shrink-0 mt-1">
                    <img
                      src="/assets/verify-2.png"
                      alt="Onay İkonu"
                      className="w-full h-full"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg sm:text-xl md:text-2xl text-[#333333] font-poppins mb-3 sm:mb-4">
                      {t("BenefitsForBusinesses")}
                    </h3>
                    <ul className="text-[#6B7C93] space-y-2 sm:space-y-1 text-sm sm:text-base md:text-lg font-poppins">
                      <li>{t("BenefitsForBusinessesDesc")}</li>
                      <li>{t("BenefitsForBusinessesDesc2")}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative order-1 lg:order-2 flex justify-center">
              <div className="relative w-full max-w-[200px] sm:max-w-[250px] md:max-w-[300px] lg:max-w-[400px] xl:max-w-[450px]">
                <img
                  src="/assets/discoverPageImg.png"
                  alt="Telefon kullanan kadın"
                  className="w-full h-auto object-contain"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="container mx-auto px-4 py-8 sm:py-8 md:py-12 lg:py-20">
        <div className="max-w-[1182px] max-h-[493px] mx-auto relative">
          <div className="w-full overflow-hidden rounded-[20px] sm:rounded-[24px] md:rounded-[28px] lg:rounded-[32px]">
            <img
              src="/assets/mockupbgdw.png"
              alt="Premium İndir Arka Plan"
              className="w-full min-h-[200px] object-cover"
              loading="lazy"
            />
          </div>

          <div className="absolute inset-0 flex flex-col justify-center items-start p-4 sm:p-8 md:p-12 lg:p-16">
            <div className="sm:max-w-[300px] md:max-w-[420px] lg:max-w-[482px] p-2 sm:py-16 md:py-12 mt-[6px] sm:mt-20 text-left">
              <h2 className="sm:text-base md:text-3xl lg:text-[35px] tracking-[1px] sm:tracking-[2px] font-semibold text-white font-poppins leading-none sm:leading-tight sm:pb-2 md:pb-4 lg:pb-6 text-left">
                {t("DownloadApp")} <br className="xs:block" />
                <span className="sm:mt-[12px]  mb-4 sm:mb-8 inline-block">
                  {t("DownloadApp2")}
                </span>
              </h2>
              <p className="text-white text-[10px] sm:text-sm md:text-base lg:text-xl font-medium font-poppins leading-none sm:leading-normal text-left">
                {t("DownloadAppDesc")} <br className="block sm:hidden" />
                <span className="mt-[5px] sm:mt-0 sm:ml-1 inline-block">
                  {t("DownloadAppDesc2")}
                </span>
                <br className="sm:block" />
                <span className="mt-[6px] inline-block">
                  {t("DownloadAppDesc3")}
                </span>
              </p>
              <div className="flex flex-row items-center gap-2 sm:gap-3 md:gap-4 pt-2 sm:pt-3 md:pt-4">
                <a
                  href="https://apps.apple.com/app/qriend"
                  className="transition-transform hover:scale-105 w-[80px] sm:w-[140px] md:w-[160px] lg:w-[200px]"
                >
                  <img
                    src="/assets/appStore.svg"
                    alt="App Store'dan İndir"
                    className="w-full h-auto"
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.qriend"
                  className="transition-transform hover:scale-105 w-[80px] sm:w-[140px] md:w-[160px] lg:w-[200px]"
                >
                  <img
                    src="/assets/googlePlay.svg"
                    alt="Google Play'den İndir"
                    className="w-full h-auto"
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Footer */}
      <Footer isHomePage={false} />
    </div>
  );
}
